export default __webpack_public_path__ + "static/media/gallery-articles_00.8369148f.jpg";